import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ['loader']

  rendered() {
    setTimeout(()=> {
      window.scroll({
        top: document.body.scrollHeight,
        behavior: "smooth"
      })
    }, 200)
    for(let loader of this.loaderTargets) {
      setTimeout((()=> loader.classList.remove('dn')), 1000)
    }
  }

  scroll() {
    this.lastScrollAtEnd = this.scrollAtEnd
  }

  get scrollAtEnd() {
    return (window.scrollTop + this.element.offsetHeight) >= window.scrollHeight
  }

}
